import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { Icon } from "../base";
import { COLORS } from "../../theme/colors";
import TickIcon from "../../assets/images/icons/tick.svg";
import { ANY_FILTER_KEY } from "../../pages/building/constants";

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    position: "relative",
    "& >p:first-child": {
      position: "absolute",
      left: -10,
    },
  },
  filterTitle: {
    cursor: "pointer",
    color: COLORS.darks[0][50],
  },
  filterContainer: {
    marginTop: theme.spacing(2),
    "&:not(.open)": {
      maxHeight: 0,
      overflow: "hidden",
      transition: "all .5s ease",
    },
    "&.open": {
      maxHeight: "400px",
      overflow: "hidden",
      transition: "all .5s ease",
    },
  },
  filterOption: {
    marginBottom: theme.spacing(2),
  },
  optionText: {
    marginRight: theme.spacing(0.5),
    cursor: "pointer",
  },
}));

export const TableFilter = ({
  filters,
  dataFilters,
  filtersCount,
  onOptionSelect,
  setDataFilters,
  count,
}) => {
  const classes = useStyles();

  const handleClick = (i) => {
    const tempDataFilters = [...dataFilters];
    tempDataFilters[i].isOpen = !tempDataFilters[i].isOpen;
    setDataFilters(tempDataFilters);
  };

  return (
    <Box>
      {dataFilters.map((filter, index) => (
        <Box key={index}>
          <Grid
            className={classes.titleContainer}
            container
            alignItems="center"
            onClick={() => handleClick(index)}
          >
            <Typography variant="body2" style={{ width: 11, cursor: "pointer" }}>
              {filter.isOpen ? "-" : "+"}
            </Typography>
            <Typography className={classes.filterTitle} variant="body2">
              {filter.title}
            </Typography>
          </Grid>

          <Box className={`${classes.filterContainer} ${filter.isOpen ? "open" : ""}`}>
            {filter.options.map((option, index) => (
              <Grid className={classes.filterOption} container key={index} alignItems="center">
                <Grid item xs={1}>
                  {filters[filter.key] === option.key && <Icon src={TickIcon} />}
                </Grid>
                <Grid item xs={11}>
                  <Grid container>
                    <Typography
                      className={classes.optionText}
                      color={filters[filter.key] === option.key ? "primary" : "initial"}
                      onClick={() => onOptionSelect(filter.key, option.key)}
                    >
                      {option.name}
                    </Typography>
                    <Typography>
                      ({option.key === ANY_FILTER_KEY ? count : filtersCount[option.key] || 0})
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
